import { baseApi } from "../baseApi";

export const billingApi = baseApi
  .enhanceEndpoints({
    addTagTypes: [
      "CashInvoices",
      "CreditNotesInvoices",
      "InsuranceInvoices",
      "CorporateInvoices",
      "GovernmentInvoices",
      "DepositInvoices",
      "WithdrawDepositInvoices",
      "CreditReceipts",
      "CreditPaid",
      "InsuranceClaimInvoices",
      "InsuranceClaimCreditInvoices",
      "PatientsDepositList",
      "PatientsCreditList",
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getCashInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listPatient",
          method: "POST",
          body: payload,
        }),
        providesTags: ["CashInvoices"],
      }),

      getCreditNotesInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listCancelPatient",
          method: "POST",
          body: payload,
        }),
        providesTags: ["CreditNotesInvoices"],
      }),

      getInsuranceInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listInsurance",
          method: "POST",
          body: payload,
        }),
        providesTags: ["InsuranceInvoices"],
      }),

      getCorporateInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listCooprate",
          method: "POST",
          body: payload,
        }),
        providesTags: ["CorporateInvoices"],
      }),

      getGovernmentInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/listGovernment",
          method: "POST",
          body: payload,
        }),
        providesTags: ["GovernmentInvoices"],
      }),

      getDepositInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/deposit/depositinvoices",
          method: "POST",
          body: payload,
        }),
        providesTags: ["DepositInvoices"],
      }),

      getWithdrawDepositInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/deposit/getWithdrawDeposits",
          method: "POST",
          body: payload,
        }),
        providesTags: ["WithdrawDepositInvoices"],
      }),

      getCreditReceipts: builder.query({
        query: (payload) => ({
          url: "/v3/patient/creditBalance/listReceipt",
          method: "POST",
          body: payload,
        }),
        providesTags: ["CreditReceipts"],
      }),

      getCreditPaid: builder.query({
        query: (payload) => ({
          url: "/v3/patient/creditPayment/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["CreditPaid"],
      }),

      getInsuranceClaimInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/insurance_claim_invoices/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["InsuranceClaimInvoices"],
      }),

      getInsuranceClaimCreditInvoices: builder.query({
        query: (payload) => ({
          url: "/v3/invoices/insurance_claim_invoices/credit/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["InsuranceClaimCreditInvoices"],
      }),

      getPatientsDepositList: builder.query({
        query: (payload) => ({
          url: "/v3/deposit/list",
          method: "POST",
          body: payload,
        }),
        providesTags: ["PatientsDepositList"],
      }),

      getPatientsCreditList: builder.query({
        query: (payload) => ({
          url: "/v3/patient/creditBalance/creditBalanceList",
          method: "POST",
          body: payload,
        }),
        providesTags: ["PatientsCreditList"],
      }),

      cancelInvoice: builder.mutation({
        query: (payload) => ({
          url: "/v3/invoices/cancelled",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["CashInvoices", "CreditNotesInvoices"],
      }),

      returnInvoice: builder.mutation({
        query: (payload) => ({
          url: "/v3/invoices/return",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["CashInvoices", "CreditNotesInvoices"],
      }),

      redoCancelInvoice: builder.mutation({
        query: (payload) => ({
          url: "/v3/invoices/redoCancel",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["CashInvoices", "CreditNotesInvoices"],
      }),

      updateInvoice: builder.mutation({
        query: (payload) => ({
          url: "/v3/invoices/update",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: [
          "CashInvoices",
          "InsuranceInvoices",
          "CorporateInvoices",
          "GovernmentInvoices",
        ],
      }),

      sendPatientInvoiceToZatca: builder.mutation({
        query: (payload) => ({
          url: "/v3/zatca/sendPatientInvoiceToZatca",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["CashInvoices"],
      }),

      sendInsuranceInvoiceToZatca: builder.mutation({
        query: (payload) => ({
          url: "/v3/zatca/sendInsuranceInvoiceToZatca",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["InsuranceInvoices"],
      }),

      addDepositBalance: builder.mutation({
        query: (payload) => ({
          url: "/v3/deposit/addBalanace",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["PatientsDepositList"],
      }),

      updateDepositBalance: builder.mutation({
        query: (payload) => ({
          url: "/v3/deposit/update-balance",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["PatientsDepositList"],
      }),

      cancelDepositBalance: builder.mutation({
        query: (payload) => ({
          url: "/v3/deposit/cancelDeposit",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["PatientsDepositList"],
      }),

      addPatientCredit: builder.mutation({
        query: (payload) => ({
          url: "/v3/patient/creditBalance/addCredit",
          method: "POST",
          body: payload,
        }),
        invalidatesTags: ["PatientsCreditList"],
      }),

      updatePatientCredit: builder.mutation({
        query: (payload) => ({
          url: "/v3/patient/creditBalance/updateCredit",
          method: "PUT",
          body: payload,
        }),
        invalidatesTags: ["PatientsCreditList"],
      }),
    }),
  });

export const {
  useGetCashInvoicesQuery,
  useLazyGetCashInvoicesQuery,
  useGetCreditNotesInvoicesQuery,
  useLazyGetCreditNotesInvoicesQuery,
  useGetInsuranceInvoicesQuery,
  useLazyGetInsuranceInvoicesQuery,
  useGetCorporateInvoicesQuery,
  useLazyGetCorporateInvoicesQuery,
  useGetGovernmentInvoicesQuery,
  useLazyGetGovernmentInvoicesQuery,
  useGetDepositInvoicesQuery,
  useLazyGetDepositInvoicesQuery,
  useGetWithdrawDepositInvoicesQuery,
  useLazyGetWithdrawDepositInvoicesQuery,
  useGetCreditReceiptsQuery,
  useLazyGetCreditReceiptsQuery,
  useGetCreditPaidQuery,
  useLazyGetCreditPaidQuery,
  useGetInsuranceClaimInvoicesQuery,
  useLazyGetInsuranceClaimInvoicesQuery,
  useGetInsuranceClaimCreditInvoicesQuery,
  useLazyGetInsuranceClaimCreditInvoicesQuery,
  useGetPatientsDepositListQuery,
  useLazyGetPatientsDepositListQuery,
  useGetPatientsCreditListQuery,
  useLazyGetPatientsCreditListQuery,
  useCancelInvoiceMutation,
  useReturnInvoiceMutation,
  useRedoCancelInvoiceMutation,
  useUpdateInvoiceMutation,
  useSendPatientInvoiceToZatcaMutation,
  useSendInsuranceInvoiceToZatcaMutation,
  useAddDepositBalanceMutation,
  useUpdateDepositBalanceMutation,
  useCancelDepositBalanceMutation,
  useAddPatientCreditMutation,
  useUpdatePatientCreditMutation,
} = billingApi;

